import { inject, Service } from '@angular/core';
import type { OnyxPaginated } from '@onyx/angular';
import type { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs';
import type { BusinessDocumentType } from '../../../../../auth/common/enums/business/business-document-type';
import type { BusinessDocuments } from '../../../../../common/interfaces/documents/business-documents';
import { ApiService } from '../../../../../common/services/api.service';
import { StorageService } from '../../../../../common/services/storage.service';
import type { DocumentsForm } from '../interfaces/documents-form';

@Service()
export class DocumentsService extends ApiService {
  private readonly storageService = inject(StorageService);

  public getDocuments(): Observable<BusinessDocuments> {
    return this.get('/business/documents');
  }

  public getProposalsDocuments(): Observable<OnyxPaginated<BusinessDocuments>> {
    return this.get('/business/documents/proposals');
  }

  public updateDocument<T extends BusinessDocumentType>(
    type: T,
    form: DocumentsForm[T],
  ): Observable<void> {
    let file: string | File | null;
    if ('ceidgAbstract' in form) {
      file = form.ceidgAbstract.file;
    } else if ('thirdPartyLiabilityInsurancePolicy' in form) {
      file = form.thirdPartyLiabilityInsurancePolicy.file;
    } else if ('regonEntry' in form) {
      file = form.regonEntry.file;
    } else if ('transportLicense' in form) {
      file = form.transportLicense.file;
    } else {
      file = form.vatStatusConfirmation.file;
    }

    return this.storageService.uploadFile(file as File).pipe(
      map(
        (file) =>
          ({
            [type]: { ...(form as any)[type], file },
          }) as Pick<BusinessDocuments, T>,
      ),
      switchMap((document: Pick<BusinessDocuments, T>) =>
        this.post<void>('/business/documents', document),
      ),
    );
  }
}
